<template>
  <div>
    <!--<h1>CbsForm</h1>-->
    <asl-projects
      v-if="objectFull.object.sid === 'asl_projects'"
      :object-full="objectFull"
    />
    <cbs-user-menu
      v-else-if="objectFull.object.sid === 'cbsfrmusermenu'"
      :object-full="objectFull"
    />
    <cbs-indicator-access
      v-else-if="objectFull.object.sid === 'frmbudgetindicatoraccess'"
      :object-full="objectFull"
    />
    <cbs-budget-request
      v-else-if="objectFull.object.sid === 'frm_budget_request'"
      :object-full="objectFull"
    />
    <cbs-nxz-budget-request
      v-else-if="renderType() === 'nxz_budget_request'"
      :object-full="objectFull"
    />
    <cbs-budget-request-access
      v-else-if="objectFull.object.sid === 'frm_budget_request_access'"
      :object-full="objectFull"
    />
    <cbs-budget-trip
      v-else-if="objectFull.object.sid === 'frm_budget_trip'"
      :object-full="objectFull"
    />
    <kbv-budget-indicator
      v-else-if="customForm() === 'kbvbudgetindicator'"
      :object-full="objectFull"
    />
    <cbs-calc-scheme
      v-else-if="objectFull.object.sid === 'cbs_calc_scheme'"
      :object-full="objectFull"
    />
    <cbs-cash-request
      v-else-if="objectFull.object.sid === 'cbs_cash_request'"
      :object-full="objectFull"
    />
    <cbs-paycal
      v-else-if="objectFull.object.sid === 'cbs_paycal'"
      :object-full="objectFull"
    />
    <cbs-tres-saldo-in
      v-else-if="objectFull.object.sid === 'tres_form_saldo_in'"
      :object-full="objectFull"
    />
    <cbs-tres-saldo-in
      v-else-if="objectFull.object.sid === 'tres_form_saldo_out'"
      :object-full="objectFull"
      saldo-out
    />
    <cbs-tres-deposit
      v-else-if="objectFull.object.sid === 'tres_form_deposit'"
      :object-full="objectFull"
    />
    <cbs-rag-tutorial
      v-else-if="objectFull.object.sid === 'cbs_frm_rag_tutorial'"
      :object-full="objectFull"
    />

    <cbs-nxz-recruit
      v-else-if="renderType() === 'nxz_recruit'"
      :object-full="objectFull"
    />

    <cbs-pivot-input
      v-else-if="renderType() === 'pivot_input'"
      :object-full="objectFull"
    />

    <cbs-form-dynamic
      v-else-if="renderType() === 'form_dynamic'"
      :object-full="objectFull"
    />

    <cbs-scenario-compare
      v-else-if="renderType() === 'scenario_compare'"
      :object-full="objectFull"
    />

    <cbs-custom-html-form
      v-else-if="customForm() === 'html'"
      :object-full="objectFull"
    />

    <cbs-debug
      v-if="session.user.sid === 'root'"
      :context="this"
    />
  </div>
</template>

<script>
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import AslProjects from '@/cubus/components/cbs-form/custom-forms/als-projects/AslProjects.vue'
import KbvBudgetIndicator from '@/cubus/components/cbs-form/custom-forms/kbv-budget-indicator/KbvBudgetIndicator.vue'
import CbsUserMenu from '@/cubus/components/cbs-form/custom-forms/user-menu/CbsUserMenu.vue'
import CbsIndicatorAccess from '@/cubus/components/cbs-form/custom-forms/indicator-access/CbsIndicatorAccess.vue'
import CbsBudgetRequest from '@/cubus/components/cbs-form/custom-forms/budget-request/CbsBudgetRequest.vue'
import CbsNxzBudgetRequest from '@/cubus/components/cbs-form/custom-forms/nxz/nxz-budget-request/CbsNxzBudgetRequest.vue'
import CbsBudgetRequestAccess from '@/cubus/components/cbs-form/custom-forms/budget-request-access/CbsBudgetRequestAccess.vue'
import useCubus from '@/cubus/services/useCubus'
import CbsBudgetTrip from '@/cubus/components/cbs-form/custom-forms/budget-trip/CbsBudgetTrip.vue'
import CbsCalcScheme from '@/cubus/components/cbs-form/custom-forms/calc-scheme/CbsCalcScheme.vue'
import CbsCashRequest from '@/cubus/components/cbs-form/custom-forms/cash-request/CbsCashRequest.vue'
import CbsPaycal from '@/cubus/components/cbs-form/custom-forms/payment-calendar/CbsPaycal.vue'
import CbsTresSaldoIn from '@/cubus/components/cbs-form/custom-forms/tres-saldo-in/CbsTresSaldoIn.vue'
import CbsTresDeposit from '@/cubus/components/cbs-form/custom-forms/tres-deposit/CbsTresDeposit.vue'
import CbsRagTutorial from '@/cubus/components/cbs-form/custom-forms/rag-tutorial/CbsRagTutorial.vue'
import CbsPivotInput from '@/cubus/components/cbs-form/generic-forms/pivot-input/CbsPivotInput.vue'
import CbsNxzRecruit from '@/cubus/components/cbs-form/custom-forms/nxz/nxz-recruit/CbsNxzRecruit.vue'
import CbsFormDynamic from '@/cubus/components/cbs-form/generic-forms/form-dynamic/CbsFormDynamic.vue'
import CbsScenarioCompare from '@/cubus/components/cbs-form/custom-forms/scenario-compare/CbsScenarioCompare.vue'
import CbsCustomHtmlForm from '@/cubus/components/cbs-form/custom-forms/html-form/CbsCustomHtmlForm.vue'

export default {
  name: 'CbsForm',
  components: {
    CbsScenarioCompare,
    CbsCustomHtmlForm,
    CbsFormDynamic,
    CbsNxzRecruit,
    CbsPivotInput,
    CbsRagTutorial,
    CbsTresDeposit,
    CbsTresSaldoIn,
    CbsPaycal,
    CbsCashRequest,
    CbsCalcScheme,
    CbsBudgetTrip,
    CbsBudgetRequestAccess,
    CbsBudgetRequest,
    KbvBudgetIndicator,
    CbsDebug,
    AslProjects,
    CbsUserMenu,
    CbsIndicatorAccess,
    CbsNxzBudgetRequest,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const session = useCubus.getSession()
    return {
      session,
    }
  },
  methods: {
    customForm() {
      if (this.objectFull && this.objectFull.params && this.objectFull.params.params) {
        const prm = this.objectFull.params.params.find(p => p.paramname === 'customform')
        if (prm) {
          return prm.paramvalue
        }
        return 'no_param'
      }
      return 'no_params'
    },
    renderType() {
      if (this.objectFull && this.objectFull.params && this.objectFull.params.params) {
        const prm = this.objectFull.params.params.find(p => p.paramname === 'render_type')
        if (prm) {
          return prm.paramvalue
        }
        return 'no_param'
      }
      return 'no_params'
    },
  },
}
</script>

<style scoped>

</style>
